"use client";
import { useParams } from "next/navigation";
import PageLayout from "@/components/layout/HomePageLayout";
import ProfileDetailContent from "@/components/profile/ProfileDetailContent";
import { useProfile } from "@/v2/hooks/profiles/useProfiles";
import { useProfileTracking } from "@/v2/hooks/profiles/useProfileTracking";
import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { ProfileData } from "@/hooks/useProfiles";
import type { PortfolioItem } from "@/hooks/profile";
interface ProfileDetailProps {
  profileOverride?: ProfileData;
  openPortfolioModal?: (item: PortfolioItem) => void;
  onClosePortfolioModal?: () => void;
}
export default function ProfileDetail({ profileOverride, openPortfolioModal, onClosePortfolioModal }: ProfileDetailProps) {
  const params = useParams();
  const identifier = params.username || params.id;
  const idOrSlug = typeof identifier === "string" ? identifier : identifier?.[0];
  const { data, isLoading, error } = useProfile(idOrSlug);
  const profile = profileOverride || data?.data;
  const { trackProfileView } = useProfileTracking();
  const queryClient = useQueryClient();
  const trackedProfile = useRef<string>();
  useEffect(() => { if (profile?.id && trackedProfile.current !== profile.id) { trackedProfile.current = profile.id; void trackProfileView(profile); } }, [profile, trackProfileView]);
  const enhancedProfile = profile ? { ...profile, hireMeEnabled: (profile as ProfileData & { hire_me_enabled?: boolean }).hire_me_enabled } : null;
  return <PageLayout><ProfileDetailContent profile={enhancedProfile} loading={isLoading && !profileOverride} error={error} onRetry={() => queryClient.invalidateQueries({ queryKey: ["profile", idOrSlug] })} isSimplifiedView={false} placeholderImage="https://world-class.design/world_class_design_open_graph.png" openPortfolioModal={openPortfolioModal} onClosePortfolioModal={onClosePortfolioModal} /></PageLayout>;
}
